<!-- <img class="footer" src="assets/footer.png"/> -->
<div class="footer-main-container">
    <div class="footer-text-container"><b>heating & cooling solutions</b></div>
    <div class="footer-image-container">
        <img src="assets/pana_urzadzenia.svg" alt="Logo">
    </div>
</div>
